import { Component } from '@angular/core';

@Component({
  selector: 'app-rectangle-list-icon',
  templateUrl: './rectangle-list-icon.component.html',
  styleUrl: './rectangle-list-icon.component.scss',
})
export class RectangleListIconComponent {}
